import React, {Component} from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'
import Divider from 'components/fulcrum/divider/Divider'
import { 
  weekSelector, 
  yearSelector, 
  roleSelector, 
  textSelector,
  roleOptionsSelector
} from 'containers/Project/WeeklyUpdateSection/selectors'
import { 
  updateWeekNumber, 
  updateYear, 
  updateRole,
  updateText
} from 'containers/Project/WeeklyUpdateSection/actions'
import WeekSelection from './WeekSelection'
import { getCurrentWeekAndYear } from 'helpers/DateUtil'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Input from 'react-toolbox/lib/input';

const mapStateToProps = (state) => {
  return {
    week: weekSelector(state),
    year: yearSelector(state),
    role: roleSelector(state),
    text: textSelector(state),
    roleOptions: roleOptionsSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateWeek: (week) => dispatch(updateWeekNumber(week)),
    updateYear: (year) => dispatch(updateYear(year)),
    updateRole: (role) => dispatch(updateRole(role)),
    updateText: (text) => dispatch(updateText(text))
  }
}

class NewUpdateDialog extends Component {

  componentDidUpdate(prevProps) {
    if (this.props.active && this.props.active !== prevProps.active) {
      const weekAndYear = getCurrentWeekAndYear(new Date())
      this.props.updateWeek(weekAndYear.week)
      this.props.updateYear(weekAndYear.year)
      if(this.props.roleOptions.length > 0){
        this.props.updateRole(this.props.roleOptions[0].value)
      }
    }
  }
  
  getForm(){
    const {
      week,
      year,
      role,
      text,
      roleOptions,
      updateWeek,
      updateYear,
      updateRole,
      updateText
    } = this.props

    return (
      <div>
        <WeekSelection 
          week={week} 
          year={year} 
          updateWeek={updateWeek} 
          updateYear={updateYear}
        />
        <div styleName='roleSelection'>
          <div>Role</div>
          <Dropdown value={role} source={roleOptions} onChange={updateRole} />
        </div>
        <div styleName='messageContainer'>
          <div>Message</div>
          <Input styleName='message' theme={styles} value={text} onChange={updateText} multiline />
        </div>
      </div>
    )
  }

  render(){
    const {
      active,
      toggleActive,
      onSave
    } = this.props

    return (
      <Dialog 
        active={active}
        onEscKeyDown={toggleActive}
        onOverlayClick={toggleActive}
        actions={[{label: "Cancel", onClick: toggleActive}, {label: "Save", onClick: onSave}]}
        title={T.translate('project.weeklyUpdates.dialog.title')}
        theme={styles}
      >
        <div styleName='container'>
          <Divider styleName='topDivider'/>
          {this.getForm()}
        </div>
      </Dialog>
    )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect,
  withStyle
)

export default enhance(NewUpdateDialog)
